<template>
    <div class="flex flex-col gap-2 text-lg mb-6">
        <div v-if="customFields?.ingredients" v-html="customFields?.ingredients" />

        <div v-if="customFields?.is_eco || hasAsteriskInIngredients">
            {{ t('product.tabsIngredients.eco') }}
        </div>

        <div v-if="customFields?.ingredients_traces_of">
            <div v-html="customFields?.ingredients_traces_of" />
        </div>

        <div v-if="customFields?.for_adults">
            {{ t('product.tabsIngredients.adult') }}
        </div>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'

const { t } = useI18n()

const props = defineProps<{
    customFields?: object | undefined
}>()

const hasAsteriskInIngredients = computed(() => {
    if (!props.customFields?.ingredients) return false

    return String(props.customFields.ingredients).includes('*')
})
</script>